<template>
  <!-- Create New Action Modal  -->
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10" @close="hideModal">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                       leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
      </TransitionChild>

      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
                           enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                           enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                           leave-from="opacity-100 translate-y-0 sm:scale-100"
                           leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
              <div>
                <div class="mt-3 sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900 text-center">Create Action</DialogTitle>
                  <div>
                    <form @submit.prevent="createAction" class="intro-y box p-5" method="POST">

                      <div class="grid grid-cols-12 gap-3 lg:gap-6 mt-3">
                        <button></button>
                        <!-- BEGIN: Name -->
                        <div class="col-span-12" :class="{'has-error': isInvalid('name')}">
                          <label for="name" class="form-label text-slate-500">Name</label>
                          <input v-model="formData.name" id="name" type="text" class="input-field w-full"
                                 name="name">
                          <div v-if="isInvalid('name')" class="error-message mt-1">{{
                              errorMessage('name')
                            }}
                          </div>
                        </div>
                        <!-- END: Name -->

                        <!-- BEGIN: Is Agency -->
                        <div v-if="user_is_admin" class="col-span-12 input-form"
                             :class="{'has-error': isInvalid('is_agency')}">
                          <div class="flex items-center justify-start space-x-2">
                            <input v-model="formData.is_agency" type="checkbox" class="input-checkbox form-check-input block" name="">
                            <span>Is this agency action?</span>
                          </div>
                          <div v-if="isInvalid('is_agency')" class="error-message mt-1">
                            {{ errorMessage('is_agency') }}
                          </div>
                        </div>
                        <!-- END: Is Agency -->
                      </div>

                      <div class="text-right mt-5">
                        <button type="submit" class="btn btn-primary w-24" :class="{'pointer-events-none': loading}">
                          <LoadingSpinner v-if="loading"></LoadingSpinner>
                          <span v-else>Submit</span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <!-- End Create Action Modal -->
</template>

<script>
import axios from "axios";
import helpers from "../../helper";
import serverValidationErrorsMixin from "../mixins/serverValidationErrorsMixin";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import LoadingSpinner from "@/Components/LoadingSpinner.vue";

export default {
  name: "ActionScheduleCreateActionModal",

  mixins: [serverValidationErrorsMixin],

  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    LoadingSpinner
  },


  props: {
    user_is_admin: {
      type: Boolean,
      required: true,
    },
    open: {
      type: Boolean,
      default: false
    }
  },

  emits: ['action-created', 'modal-hidden'],

  data() {
    return {
      modalName: 'createActionModal',
      loading: false,
      formData: {
        name: null,
        is_agency: false,
      },
    }
  },

  methods: {
    createAction() {
      if (this.loading) return;

      this.loading = true;

      setTimeout(() => {
        axios
          .post(`/actions`, this.formData)
          .then((response) => {
            this.handleSuccessfulSubmission(response)
          })
          .catch((error) => {
            this.handleErroredSubmission(error);
          })
          .finally(() => {
            this.loading = false;
          })
      }, 500)
    },

    handleSuccessfulSubmission(response) {
      this.$emit('action-created', {action: response.data.action});
      this.formData = {
        name: null,
        is_agency: false,
      };
      this.errors = {};
      this.hideModal();
    },

    handleErroredSubmission(error) {
      console.log(error);
      if (error.response && error.response.data && error.response.status === 422) {
        this.errors = error.response.data.errors;
        this.$nextTick(() => {
          helpers.scrollToClass('has-error');
        })
      } else {
        Swal.fire({
          text: 'Unknown error occurred, please try again.',
          icon: 'error'
        });
      }
      console.log("ActionScheduleCreateActionModal - handleErroredSubmission", error.response);
    },

    hideModal() {
      this.$emit('modal-hidden', this.modalName)
    },
  },
}
</script>

<style scoped>

</style>